import makhana from '../../assets/home/makhana-product.png'
import makhanaPudina from '../../assets/product13/chesse-flavour (1).png'
import { Link } from 'react-router-dom'

const mindblowflavour=()=>{
    return(
        <>
            <div className="container-fluid" style={{
                background:'black',
                overflow:'hidden'
            }}>
                <div className="container">
                    <h2 className="text-center pt-5"
                        style={{
                            fontWeight:'600',
                            color:'white'
                        }}
                    >Flavours that blow your Mind</h2>
                    <div className="row pt-5 pb-5">
                        <div className="col-md-6 p-2">
                            <div style={{
                                border:'3px solid none',
                                width:'100%',
                                borderRadius:'10px'
                            }}>     
                            <Link to="https://eatful.in/product/2">                          
                               <img src={makhana} style={{
                                width:'100%',
                                borderRadius:'8px',
                                height:'600px'
                               }} alt="makhana chill produuct "/>
                            </Link>
                            </div>
                        </div>
                        <div className="col-md-6 p-2">
                            <div style={{
                            }}>
                            <Link to="https://eatful.in/product/14">                          
                               <img src={makhanaPudina} style={{
                                width:'100%',
                                height:'600px',
                                borderRadius:'8px'
                               }} alt="makhana chill produuct "/>
                            </Link>                                    
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default mindblowflavour